import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { useSelector } from 'react-redux';
import { Button } from '@material-ui/core';
import { RootState } from '../../../redux/root';
import { InputTextWithLabel } from '../../../molecules';
import { dispatch } from '../../../redux/store';
import { setSelectedJurisdiction } from '../../../redux/slices/wikiSlice';
import { Buttons } from '../Inspections/ContactDataPopup';
import { objectKeysToSnakeCase } from '../../../utils';
import { useUpdateJurisdictionMutation } from '../../../redux/rtkQuery/apiWikiSlice';

const JurisdictionWebsiteLinkPopup = ({ show, setShow, setValue }) => {
  const selectedJurisdiction = useSelector((s: RootState) => s.wikiSlice.selectedJurisdiction);
  const name = 'jurisdictionWebsite';
  const [updateJurisdiction] = useUpdateJurisdictionMutation();
  const [data, setData] = useState<any>();

  useEffect(() => {
    setData(selectedJurisdiction);
    setValue(name, selectedJurisdiction.jurisdictionWebsite);
  }, [selectedJurisdiction, show]);

  const setLink = async link => {
    const _selectedJuri = {
      ...data,
      jurisdictionWebsite: link,
    };

    setData(_selectedJuri);
  };

  const onSave = async () => {
    dispatch(setSelectedJurisdiction(data));
    setValue(name, data.jurisdictionWebsite);
    await updateJurisdiction(objectKeysToSnakeCase({ id: selectedJurisdiction.id, jurisdictionWebsite: data.jurisdictionWebsite }));
    setShow(false);
  };
  return (
    <>
      {show && (
        <LinkPopup>
          <InputTextWithLabel
            name="portalLinkDescription"
            label="Website URL"
            value={data.jurisdictionWebsite}
            onChange={e => setLink(e.target.value)}
          />
          <Buttons>
            <Button variant="contained" color="primary" onClick={e => setShow(false)}>
              Cancel
            </Button>
            <Button variant="contained" color="primary" onClick={onSave} disabled={!data.jurisdictionWebsite}>
              Save
            </Button>
          </Buttons>
        </LinkPopup>
      )}
    </>
  );
};

export default JurisdictionWebsiteLinkPopup;

const LinkPopup = styled.div`
  position: absolute;
  top: 0;
  left: calc(100% + 8px);
  width: 340px;
  max-width: calc(100vw - 48px);
  padding: 16px;
  background-color: var(--neutral-0);
  z-index: 20;
  border: 1px solid var(--border);
  border-radius: 10px;
  box-shadow: var(--shadow-lg, 0 12px 24px rgba(15, 23, 42, 0.12));
`;
